import React from "react";
import styles from "./CountBubble.module.scss";

export default function CountBubble({count}) {
  return (
    <div className={styles.module}>
      <span className={styles.count}>{count}</span>
    </div>
  )
}